import { useEffect, useRef } from 'react';

import useAssets from '@/ui/hooks/use-assets';
import useAvailableToAssets from './use-available-to-assets.js';

function useInitialSwapPair(
  fromAssetName?: string,
): [string, string] | undefined {
  const initialPairReturnedRef = useRef(false);

  const assets = useAssets();
  const fromAssetTicker = fromAssetName
    ? assets[fromAssetName]?.ticker
    : undefined;
  const { availableToAssets } = useAvailableToAssets(fromAssetTicker);
  const toAssetName = availableToAssets[0]?.name;

  useEffect(() => {
    if (initialPairReturnedRef.current || !toAssetName) {
      return;
    }

    initialPairReturnedRef.current = true;
  }, [toAssetName]);

  if (initialPairReturnedRef.current || !fromAssetName) {
    return;
  }

  return [fromAssetName, toAssetName];
}

export default useInitialSwapPair;
